import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import authRoutes from './auth/index';
import dashboardRoutes from './dashboard/index';
import errorRoutes from './error';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: 'home' */ '@/pages/Home.vue'),
  },
  authRoutes,
  dashboardRoutes,
  errorRoutes,
  {
    path: '*',
    component: () => import(/* webpackChunkName: "error" */ '@/pages/error/E404.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
